import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import '@shared/brand.css';
import './admin.css';
import { App } from './App';

// Prompt-style update: a new build activates on next launch, never mid-drawing.
registerSW({ immediate: true });

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
